/* ============================================================================
   EASTEAM · THE FITTING ROOM — style patch
   ----------------------------------------------------------------------------
   Two corrections to the widget, applied as an extra stylesheet inside its
   shadow root. Loaded straight after easteam-fitting-room.js.

   1. TYPOGRAPHY. The prototype declared its base font on `body`, and a `body`
      selector matches nothing inside a shadow root — so body copy fell back to
      the browser's serif. The same declarations are re-applied to :host, which
      every node in the widget inherits from.

   2. DESKTOP POSITION. The sheet is docked to the bottom of the viewport, which
      is right on a phone and reads as a mobile pattern on a laptop. From 768px
      up it centres instead, with its corners and a softer entrance.

   This exists so the fixes could ship without re-uploading the 105KB main file.
   When that file is next replaced wholesale, both rules are already in it and
   this patch can be deleted along with its <script> tag in the snippet.
   ========================================================================== */
(function () {
  "use strict";
  if (window.__EA_FR_PATCH__) return;
  window.__EA_FR_PATCH__ = 1;

  var CSS = [
    ':host{font-family:var(--body);font-weight:300;color:var(--ink);',
    '  -webkit-font-smoothing:antialiased;line-height:1.7}',
    '.scrim,.modal,.fabwrap,.zoomov{font-family:var(--body);font-weight:300;color:var(--ink)}',
    '@media(min-width:768px){',
    '  .scrim{align-items:center;padding:4vh 0}',
    '  .modal{border-radius:4px;box-shadow:0 18px 60px rgba(10,8,7,.45);',
    '    animation:riseCentre .42s cubic-bezier(.25,0,.2,1) both}',
    '}',
    '@keyframes riseCentre{from{transform:translateY(2%) scale(.98);opacity:0}',
    '  to{transform:none;opacity:1}}'
  ].join('\n');

  var tries = 0;

  function apply() {
    var host = document.getElementById('ea-fitting-room');
    var root = host && host.shadowRoot;
    if (!root) {
      /* the widget mounts on DOMContentLoaded; give it ~10s, then give up */
      if (tries++ < 100) setTimeout(apply, 100);
      return;
    }
    if (root.querySelector('style[data-ea-fr-patch]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-ea-fr-patch', '1');
    s.textContent = CSS;
    root.appendChild(s);   /* last in the sheet order, so these rules win */
  }

  apply();
})();
